import React from 'react';
import PropTypes from 'prop-types';

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';

const Header = ({ header, classes }) => {
    const rest = header.slice(1);
    const dataColumns = rest.map(col => (
        <TableCell key={col} numeric>
            {col}
        </TableCell>
    ));
    return (
        <TableHead>
            <TableRow>
                <TableCell>{header[0]}</TableCell>
                {dataColumns}
            </TableRow>
        </TableHead>
    );
};

Header.propTypes = {
    header: PropTypes.array.isRequired,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/report/Header.js